import React, { useContext } from 'react';
import styled from 'styled-components';
import { FdrProductTravelType } from '@hotelplan/supergraph-api';
import CurrentSearchContext from 'components/domain/currentSearch/CurrentSearchContext';
import { FdrSearchControlFormLayout } from 'fdr/components/candidate/fdr-search-control/form-layout';
import FdrTravelRoomsFieldContainer from 'fdr/components/candidate/fdr-search-control/travel-rooms/fdr-travel-rooms-field-container';
import { useFdrFourTravelRooms } from 'fdr/components/candidate/fdr-search-control/travel-rooms/use-fdr-four-travel-rooms';
import { FdrTravelTypeField } from 'fdr/components/candidate/fdr-search-control/travel-type/fdr-travel-type-field';
import { FdrCommonFormLayout } from 'fdr/components/local/fdr-common-form-layout/fdr-common-form-layout';
import { FdrSearchTravelDates } from 'fdr/components/local/fdr-search-travel-dates';

const SearchControlFormLayoutWrapper = styled(FdrSearchControlFormLayout)(
  ({ theme }) => theme.forms.shortBannerForm
);

const WishlistSearchControlDesktopFormContainer = () => {
  const { ref } = useContext(CurrentSearchContext);
  const { isValid: isTravelRoomsValid, isEmpty } = useFdrFourTravelRooms();

  return (
    <div ref={ref}>
      <SearchControlFormLayoutWrapper
        travelTypes={
          <FdrTravelTypeField
            withAutoSubmitOnChange
            mainTravelTypes={[
              FdrProductTravelType.Package,
              FdrProductTravelType.HotelOnly,
            ]}
          />
        }
      >
        <FdrCommonFormLayout
          travelDates={<FdrSearchTravelDates disabled={!isTravelRoomsValid} />}
          travelRooms={<FdrTravelRoomsFieldContainer />}
          isSubmitAllowed={isTravelRoomsValid && !isEmpty}
        />
      </SearchControlFormLayoutWrapper>
    </div>
  );
};

export default WishlistSearchControlDesktopFormContainer;
